import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

interface ReleaseNotesVisibilityState {
    isOpen: boolean;
    /** Version acknowledged by the user; the snack re-opens when a newer one is published. */
    lastSeenVersion: string;
}

const initialState: ReleaseNotesVisibilityState = {
    isOpen: true,
    lastSeenVersion: ''
};

const releaseNotesVisibilitySlice = createSlice({
    name: 'releaseNotesVisibility',
    initialState,
    reducers: {
        openReleaseNotes: (state) => {
            state.isOpen = true;
        },
        closeReleaseNotes: (state, action: PayloadAction<string>) => {
            state.isOpen = false;
            state.lastSeenVersion = action.payload;
        },
        toggleReleaseNotes: (state) => {
            state.isOpen = !state.isOpen;
        }
    }
});

export const { openReleaseNotes, closeReleaseNotes, toggleReleaseNotes } = releaseNotesVisibilitySlice.actions;

const persistConfig = {
    key: 'releaseNotesVisibility',
    storage,
    whitelist: ['isOpen', 'lastSeenVersion']
};

export const persistedReleaseNotesVisibilityReducer = persistReducer(persistConfig, releaseNotesVisibilitySlice.reducer);
